import { Package, Layers, Tag, AlertTriangle } from "lucide-react";

const Kpi = ({ icon: Icon, label, value, accent, testid, sub }) => (
  <div
    data-testid={testid}
    className="fade-up rounded-2xl border border-border bg-card p-4 transition-colors hover:bg-[#1f2937]"
  >
    <div className="flex items-center justify-between">
      <span className="text-[11px] font-medium uppercase tracking-wider text-muted-foreground">
        {label}
      </span>
      <span className={`flex h-8 w-8 items-center justify-center rounded-lg ${accent}`}>
        <Icon className="h-4 w-4" />
      </span>
    </div>
    <div className="mt-3 font-heading text-2xl sm:text-3xl font-bold text-slate-50 tabular-nums">
      {value}
    </div>
    {sub && <div className="mt-0.5 text-[11px] text-muted-foreground">{sub}</div>}
  </div>
);

export const KpiBar = ({ items }) => {
  const totalItems = items.length;
  const totalQty = items.reduce((s, i) => s + (Number(i.quantity) || 0), 0);
  const categories = new Set(items.map((i) => i.category)).size;
  const lowStock = items.filter((i) => (Number(i.quantity) || 0) <= 2).length;

  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-4 mb-6">
      <Kpi
        testid="kpi-total-items"
        icon={Package}
        label="Total SKUs"
        value={totalItems}
        sub="unique line items"
        accent="bg-primary/15 text-primary"
      />
      <Kpi
        testid="kpi-total-quantity"
        icon={Layers}
        label="Total Quantity"
        value={totalQty}
        sub="units on hand"
        accent="bg-accent/15 text-accent"
      />
      <Kpi
        testid="kpi-categories"
        icon={Tag}
        label="Categories"
        value={categories}
        sub="active groups"
        accent="bg-purple-500/15 text-purple-400"
      />
      <Kpi
        testid="kpi-low-stock"
        icon={AlertTriangle}
        label="Low Stock"
        value={lowStock}
        sub="qty ≤ 2"
        accent="bg-amber-500/15 text-amber-400"
      />
    </div>
  );
};
